import { AccessDenied } from './AccessDenied'
import { TechnicalDifficulties } from './TechnicalDifficulties'

export const TechnicalIssues = ({ error }: { error: number }) => {
  return error === 403 ? <AccessDenied /> : <TechnicalDifficulties />
}
